import { LocalDate, ZoneId } from 'js-joda';
import { combineLatest } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { IftaConstantsService } from '../constants';
import { TaxAccountService } from '../tax-account/tax-account.service';
import { TimeTransform, VehicleTransform } from '../transformations';
import { UserService } from '../user';
import { VehicleService } from '../vehicle';
import * as i0 from "@angular/core";
import * as i1 from "../user/user.service";
import * as i2 from "../constants/ifta-constants.service";
import * as i3 from "../vehicle/vehicle.service";
import * as i4 from "../tax-account/tax-account.service";
export class FiltersService {
    constructor(userService, constantsService, vehicleService, taxAccountService) {
        this.userService = userService;
        this.constantsService = constantsService;
        this.vehicleService = vehicleService;
        this.taxAccountService = taxAccountService;
    }
    getBusinessAccountId() {
        return this.userService.getBusinessAccount();
    }
    getDefaultDateRange() {
        return this.constantsService.getCurrentQuarter().pipe(mergeMap(quarter => this.constantsService.getDatesforQuarter(quarter).pipe(map(dates => {
            const startDate = TimeTransform.split(dates[0]).date;
            const endDate = TimeTransform.parse(this.getTodaysDate()).date;
            return {
                startDate,
                endDate
            };
        }))));
    }
    getTaxAccounts() {
        const baid = this.getBusinessAccountId();
        return this.taxAccountService
            .getTaxAccounts({
            pageSize: '1000',
            pageToken: '1'
        }, baid)
            .pipe(map(response => response.items));
    }
    getVehicles(taxAccountId) {
        const baid = this.getBusinessAccountId();
        switch (taxAccountId || '') {
            case '':
                return this.getAllVehicles();
            case 'unassigned':
                return this.getUnassignedVehicles(baid);
            default:
                return this.getVehicleIdsForTaxAccount(baid, taxAccountId);
        }
    }
    getAllVehicles() {
        const baid = this.getBusinessAccountId();
        return this.vehicleService
            .getAllVehicles(baid)
            .pipe(map(vehicles => vehicles.map(VehicleTransform.fromAPI)));
    }
    getUnassignedVehicles(businessAccountId) {
        const allVehicles$ = this.getAllVehicles();
        const unassignedVehicleIds$ = this.taxAccountService.getUnassignedVehicleIds(businessAccountId);
        return combineLatest(allVehicles$, unassignedVehicleIds$).pipe(map(([allVehicles, unassignedVehicleIds]) => allVehicles.filter(vehicle => unassignedVehicleIds.includes(vehicle.id))));
    }
    getVehicleIdsForTaxAccount(businessAccountId, taxAccountId) {
        const allVehicles$ = this.getAllVehicles();
        const assignedVehicleIds$ = this.taxAccountService.getVehicleIdsForTaxAccount(businessAccountId, taxAccountId);
        return combineLatest(allVehicles$, assignedVehicleIds$).pipe(map(([allVehicles, assignedVehicleIds]) => allVehicles.filter(vehicle => assignedVehicleIds.includes(vehicle.id))));
    }
    getTodaysDate() {
        return this.getDateAtEndOfDay(LocalDate.now());
    }
    getDefaultStartDate() {
        return LocalDate.now()
            .minusYears(1)
            .plusDays(1)
            .toString();
    }
    getDefaultEndDate() {
        return LocalDate.now().toString();
    }
    parseStartDate(date) {
        if (!date) {
            return null;
        }
        return LocalDate.parse(date)
            .atStartOfDayWithZone(ZoneId.UTC)
            .toInstant()
            .toString();
    }
    parseEndDate(date) {
        if (!date) {
            return null;
        }
        return this.getDateAtEndOfDay(LocalDate.parse(date));
    }
    getDateAtEndOfDay(date) {
        return date
            .atStartOfDayWithZone(ZoneId.UTC)
            .plusDays(1)
            .minusSeconds(1)
            .toInstant()
            .toString();
    }
}
FiltersService.ngInjectableDef = i0.defineInjectable({ factory: function FiltersService_Factory() { return new FiltersService(i0.inject(i1.UserService), i0.inject(i2.IftaConstantsService), i0.inject(i3.VehicleService), i0.inject(i4.TaxAccountService)); }, token: FiltersService, providedIn: "root" });
